module.exports = __webpack_public_path__ + "img/bDrive.fd0a583d.svg";